import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.quiz');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';
const Quiz = [
    {
        type: 'multiple',
        question: '주식회사 SEASON은\n어떤 기술을 구현하는 회사일까요?',
        options: ['웹툰 만화 기술', '인공지능(AI) 기술', '제조 기술', '요리 기술'],
        answer: '인공지능(AI) 기술',
        src: "Q1.png"
    },
    {
        type: 'multiple',
        question: 'SEASON이 개발한 DIZEST는\n어떤 단위로 연결하여 사용자가\n쉽게 사용할 수 있을까요?',
        options: ['파일 단위', '종이 단위', '블럭 단위', '문자 단위'],
        answer: '블럭 단위',
        src: "Q2.png"
    },
    {
        type: 'multiple',
        question: 'SEASON이 개발한 DIZEST는\n주로 어떤 목적으로 사용될까요?',
        options: ['음악 자동 연주', '요리 자동화', '여행 사진 공유', '업무 자동화'],
        answer: '업무 자동화',
        src: "Q3.png"
    },
    {
        type: 'multiple',
        question: '컴퓨터가 인간처럼 학습하고\n해결하고 의사결정을 내리는 기술’을\n우리는 무엇이라고 부를까요?',
        options: ['인터넷', '인공지능(AI)', '스마트폰', '로켓 과학'],
        answer: '인공지능(AI)',
        src: "Q4.jpg"
    },
    {
        type: 'multiple',
        question: 'AI기술을 활용하여 사람처럼\n대화할 수 있는 챗봇으로\n유명한 모델은 무엇일까요?',
        options: ['ChatGPT', '구글 번역기', '엑셀 함수', '파워포인트'],
        answer: 'ChatGPT',
        src: "Q5.png"
    },
    {
        type: 'multiple',
        question: '세계 최초로 인간과 체스 게임에서\n승리한 AI 프로그램의 이름은 무엇일까요?',
        options: ['알파고 (AlphaGo)', '딥 블루 (Deep Blue)', '왓슨 (Watson)', '시리 (Siri)'],
        answer: '딥 블루 (Deep Blue)',
        src: "Q6.jpg"
    },
];

@Component({
    selector: 'wiz-portal-kiosk-quiz',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.quiz/view.scss */
/* src/app/portal.kiosk.quiz/view.scss: no such file or directory */`],
})
export class PortalKioskQuizComponent implements OnInit {

    public num: number = 0;
    public quizzes: Quiz[] = JSON.parse((JSON.stringify(Quiz)));
    public selectedQuizzes: Quiz[] = [];
    public selectedOptionIndex: number | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.selectedQuizzes = this.getShuffledQuizzes();
        await this.service.render();
    }

    public getShuffledQuizzes(): Quiz[] {
        const multipleChoice = this.quizzes.filter(q => q.type === 'multiple');
        const oxChoice = this.quizzes.filter(q => q.type === 'ox');
        const shuffledMultiple = this.shuffle(multipleChoice).slice(0, 6);
        const shuffledOX = this.shuffle(oxChoice).slice(0, 2);
        return [...shuffledMultiple, ...shuffledOX];
    }

    public shuffle<T>(array: T[]): T[] {
        const copied = [...array];
        for (let i = copied.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copied[i], copied[j]] = [copied[j], copied[i]];
        }
        return copied;
    }

    public async selectOption(value: any) {
        this.selectedQuizzes[this.num].response = value;
        await this.service.render(100);
        console.log(this.selectedQuizzes)

        if (this.num + 1 >= this.selectedQuizzes.length) {
            this.router.navigate(
                ['/main/score'],
                { queryParams: { score: this.selectedQuizzes.length } }
            );
        } else {
            this.num++;
            this.service.render();
        }
    }
}

export default PortalKioskQuizComponent;